export function anonymize_tiktok_data(
    json_object,
    donate_like_history = true,
    donate_search_history = true,
    donate_share_history = true,
    donate_session_times = true,
    donate_favorites = true,
    donate_following = true,
    donate_followers = true,
    donate_comments = true,
    donate_comments_text = true,
    donate_ads = true,
    donate_settings = true,
) {
    if ('Your Activity' in json_object) {
        var activity = json_object['Your Activity'];
        if (('Watch History' in activity) == false) {
            return false;
        }
        if (('Like List' in activity) == false) {
            return false;
        }
        if (('Searches' in activity) == false) {
            return false;
        }
        if (('Share History' in activity) == false) {
            return false;
        }
    }
    else {
        return false;
    }

    var comments = json_object['Comment'];

    if (donate_followers == false) {
        if ('Follower' in activity) {
            delete activity['Follower'];
        }
    }

    if (donate_following == false) {
        if ('Following' in activity) {
            delete activity['Following'];
        }
    }

    if (donate_favorites == false) {
        if ('Favorite Effects' in activity) {
            delete activity['Favorite Effects'];
        }
        if ('Favorite Sounds' in activity) {
            delete activity['Favorite Sounds'];
        }
        if ('Favorite Hashtags' in activity) {
            delete activity['Favorite Hashtags'];
        }
        if ('Favorite Videos' in activity) {
            delete activity['Favorite Videos'];
        }
    }

    if (donate_like_history == false) {
        if ('Like List' in activity) {
            delete activity['Like List'];
        }
    }

    if (donate_search_history == false) {
        if ('Searches' in activity) {
            delete activity['Searches'];
        }
    }

    if (donate_share_history == false) {
        if ('Share History' in activity) {
            delete activity['Share History'];
        }
    }

    if (donate_session_times) {
        // Iterate through sessions and delete personal data
        try {
            var login_history_list = activity['Login History']['LoginHistoryList'];
            for (var i = 0; i < login_history_list.length; ++i) {
                delete login_history_list[i]['IP']
                delete login_history_list[i]['IP'];
                delete login_history_list[i]['DeviceModel'];
                delete login_history_list[i]['DeviceSystem'];
                delete login_history_list[i]['NetworkType'];
                delete login_history_list[i]['Carrier'];
            }
        }
        catch (err) {
        }
    }
    else {
        delete activity['Login History'];
    }

    if ('Purchase History' in activity) {
        delete activity['Purchase History'];
    }
    if ('Status' in activity) {
        delete activity['Status'];
    }


    if (donate_comments == false) {
        var anonymized_user_object = { 'Activity': activity };
    }
    else {
        try {
            if (donate_comments_text == false) {
                var commentList = comments['Comments']['CommentsList'];
                for (var i = 0; i < commentList.length; ++i) {
                    commentList[i]['Comment'] = '[redacted]';
                }
            }
            var anonymized_user_object = { 'Activity': activity, 'Comment': comments };
        }
        catch (err) { }
    }



    if ('App Settings' in json_object) {
        var settings = json_object['App Settings']['Settings']['SettingsMap'];
        if (donate_settings) {
            anonymized_user_object['Settings'] = settings;
        }
    }

    if (donate_ads) {
        if ('Ads and data' in json_object) {
            var ads = json_object['Ads and data'];
            anonymized_user_object['Ads and data'] = ads;
        }
    }

    return anonymized_user_object;
}

export function anonymize_youtube_data(
    watchHistory,
    searchHistory,
    comments,
    subscriptions,
    likedVideos
) {

    var anonymized_user_object = {'watchHistory': watchHistory};

    if (searchHistory !== null) {
        anonymized_user_object['searchHistory'] = searchHistory;
    }

    if (comments !== null) {
        anonymized_user_object['comments'] = comments;
    }

    if (subscriptions !== null) {
        anonymized_user_object['subscriptions'] = subscriptions;
    }

    if (likedVideos !== null) {
        anonymized_user_object['likedVideos'] = likedVideos;
    }

    return anonymized_user_object;
}

export function anonymize_instagram_data(
    adsAndTopics,
    adsAndBusinesses,
    yourTopics,
    appsAndWebsites,
    recentSearches,
    linkHistory,
    subscriptionsInstagram,
    storyInteractions,
    saved,
    likes,
    commentsInstagram,
) {

    var anonymized_user_object = {'adsAndTopics': adsAndTopics};

    if (adsAndBusinesses !== null) {
        anonymized_user_object['adsAndBusinesses'] = adsAndBusinesses;
    }
    if (yourTopics !== null) {
        anonymized_user_object['yourTopics'] = yourTopics;
    }
    if (appsAndWebsites !== null) {
        anonymized_user_object['appsAndWebsites'] = appsAndWebsites;
    }
    if (recentSearches !== null) {
        anonymized_user_object['recentSearches'] = recentSearches;
    }
    if (linkHistory !== null) {
        anonymized_user_object['linkHistory'] = linkHistory;
    }
    if (subscriptionsInstagram !== null) {
        anonymized_user_object['subscriptionsInstagram'] = subscriptionsInstagram;
    }
    if (storyInteractions !== null) {
        anonymized_user_object['storyInteractions'] = storyInteractions;
    }
    if (saved !== null) {
        anonymized_user_object['saved'] = saved;
    }
    if (likes !== null) {
        anonymized_user_object['likes'] = likes;
    }
    if (commentsInstagram !== null) {
        anonymized_user_object['commentsInstagram'] = commentsInstagram;
    }
    return anonymized_user_object;
}